import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export const OurTeamPurpleSectionContainer = styled.div`
  max-width: 100vw !important;
  margin: 0 auto;
  background-color: #EDF8FA;
  box-sizing: border-box;
  padding: 14rem 3rem 5rem;
  position: relative;

  > h1 {
    margin-bottom: 2.5rem;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  @media all and (max-width: ${layout.sm}) {
    padding: 6rem 1.8rem 2.9rem;

    > h1 {
      padding: 0em 1em;
      margin-bottom: 1rem;
    }
  }
`

export const OurTeamCultureFeatText = styled.div`
  display: grid;
  margin-bottom: 1.5em;
  padding: 2.5rem 2em 1rem;

  > p {
    max-width: 420px;
    margin: 0 auto;
  }

  @media all and (max-width: ${layout.sm}) {
    margin-bottom: 0;
    padding: 1.5rem 2rem;
  }
`

export const OurTeamText = styled.div`
  display: grid;
  padding: 0em 2em;
  margin: 0 auto;

  a {
    margin-top: 5px;
    -webkit-font-smoothing: antialiased;
    color: ${palette.white};

    span {
      line-height: 1.45rem;
      text-align: center;

      > svg > path {
        fill: ${palette.white};
      }
    }
  }

  @media all and (max-width: ${layout.sm}) {
    grid-row-gap: 1rem;

    > p {
      max-width: 210px;
    }

    a {
      font-size: 1rem;
    }
  }
`

export const OurTeamTextList = styled.div`
  display: grid;
  padding: 0em 2em;
  margin: 0 auto .5em;

  @media all and (max-width: ${layout.sm}) {
    max-width: 230px;

    > p {
      text-align: left;
      display: list-item;
    }
  }
`

export const CulturalFitAction = styled.div`
  display: grid;
  width: 100%;
  margin-top: 2.5rem;

  & > a {
    width: 256px;
  }
`

export const PurpleBackground = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1;
  background: #90317C;
  left: 0;
  bottom: -1px;
  clip-path: polygon(13% 14%,100% 0,100% 100%,0 100%,0 35%);

  @media screen and (max-width: ${layout.sm}){
    box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.25);
    clip-path: polygon(0 8%, 100% 0, 100% 100%, 0 100%);
  }
`

const confettiTriagle = 'data:image/svg+xml;base64,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';
const confettiPentagon = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUxIiBoZWlnaHQ9IjI5NyIgdmlld0JveD0iMCAwIDE1MSAyOTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik02MC42NDY0IDAuMDgyOTgzNEwwLjM5MTE4OSAxNDEuMTY0TDU1Ljc0OTMgMjUxLjgwOUwyMDguOTY0IDI5Ni41MjdMMjY4LjQ5MiAxNDUuMzY5TDIxNi4yNjcgNDAuOTg3M0w2MC42NDY0IDAuMDgyOTgzNFoiIGZpbGw9IiM4MEQxQ0QiLz4KPC9zdmc+Cg==';

export const ConfettiBackground = styled.div`
  width: 100%;
  height: 100%;

  background:
      url(${confettiTriagle}) 0% 68% / 223px auto no-repeat,
      url(${confettiPentagon}) 100% 25% / 110px auto no-repeat;

  @media screen and (max-width: ${layout.subLg}) {
    background:
      url(${confettiTriagle}) 0% 68% / 180px auto no-repeat,
      url(${confettiPentagon}) 100% 45% / 95px auto no-repeat;
  }

  @media screen and (max-width: ${layout.sm}) {
    background:
      url(${confettiTriagle}) -6% 28% / 120px auto no-repeat,
      url(${confettiPentagon}) 106% 72% / 60px auto no-repeat;
  }
`
